module.exports = __webpack_public_path__ + "img/chart-bar 1diff-level.1012bbad.svg";